// Slovak translations
export default {
  sidebar: {
    menu: "Menu",
    adminSection: "Administrácia",
    dashboard: "Prehľad",
    employees: "Zamestnanci",
    workplaces: "Pracoviská",
    statuses: "Stavy",
    automations: "Automatizácie",
    tests: "Testy",
    export: "Export",
    asistent: "Asistent",
    requests: "Žiadosti",
    activity: "Aktivita",
    broadcastSection: "Komunikácia",
    inAppMessages: "Hromadná správa",
    userManagement: "Správa používateľov",
    support: "Podpora",
    logout: "Odhlásiť sa"
  },
  common: {
    search: "Hľadať...",
    add: "Pridať",
    save: "Uložiť",
    cancel: "Zrušiť",
    delete: "Zmazať",
    edit: "Upraviť",
    close: "Zavrieť",
    confirm: "Potvrdiť",
    loading: "Načítava sa...",
    error: "Chyba",
    success: "Úspech",
    actions: "Akcie",
    filter: "Filtrovať",
    sort: "Zoradiť",
    noData: "Žiadne dáta",
    role: "Rola",
    lightMode: "Svetlý režim",
    darkMode: "Tmavý režim"
  },
  onboardingFlow: {
    welcome: {
      title: "Vitajte v Effzone 👋",
      subtitle: "O pár minút budete pripravení na prvý záznam dochádzky. Prevedieme vás nastavením — pracovisko, zamestnanci a QR plagát.",
      highlightQr: "QR dochádzka",
      highlightSms: "SMS pozvánky",
      highlightInsights: "Prehľady a mzdy",
      start: "Poďme na to",
      skip: "Preskočiť, poobzerám sa sám",
    },
    wizard: {
      title: "Rýchle nastavenie",
      stepPersonalize: "Personalizácia",
      personalizeHeading: "Prispôsobte si Effzone",
      personalizeHint: "Vyberte si jazyk a vzhľad — všetko sa dá kedykoľvek zmeniť v bočnom menu.",
      personalizeNote: "Zmeny sa prejavia okamžite — vyskúšajte si to.",
      personalizeCompanyLabel: "Názov firmy",
      personalizeCompanyPlaceholder: "napr. Pekáreň Novák",
      personalizeCompanyRequired: "Zadajte názov firmy — zobrazí sa zamestnancom v appke aj v SMS pozvánke.",
      languageLabel: "Jazyk administrácie",
      themeLabel: "Vzhľad",
      themeLight: "Svetlý",
      themeDark: "Tmavý",
      railHint: "Nastavenie zaberie pár minút. Všetko sa dá kedykoľvek zmeniť — nič nie je definitívne.",
      stepWorkplace: "Pracovisko",
      stepEmployees: "Zamestnanci",
      stepPoster: "QR plagát",
      stepDone: "Hotovo",
      workplaceHeading: "Vytvorte prvé pracovisko",
      workplaceHint: "Miesto, kde si zamestnanci budú označovať príchod — predajňa, sklad, kancelária…",
      workplaceLabel: "Názov pracoviska",
      workplacePlaceholder: "napr. Predajňa Bratislava",
      workplaceExisting: "Použije sa pracovisko:",
      workplaceSelectHint: "Toto sú vaše pracoviská — každé má vlastný QR kód. Môžete pridať ďalšie, koľko potrebujete.",
      employeesAssignLabel: "Priradiť na pracovisko",
      posterWorkplaceLabel: "Plagát pre pracovisko",
      workplaceAddAnother: "Pridať ďalšie pracovisko",
      workplaceCreateBtn: "Vytvoriť",
      workplaceRequired: "Zadajte názov pracoviska alebo vyberte existujúce.",
      employeesHeading: "Pridajte zamestnancov",
      employeesHint: "Stačí meno a telefónne číslo — ním sa prihlásia do mobilnej appky. Automaticky ich priradíme na pracovisko {workplace}.",
      employeeName: "Meno",
      employeePhone: "Telefón (+421...)",
      employeePosition: "Pozícia (nepovinné)",
      addRow: "Pridať ďalšieho",
      importTitle: "Hromadný import zo súboru",
      importSubtitle: "Nahrajte Excel či CSV so zamestnancami — AI rozpozná mená, čísla aj pozície, nech sú stĺpce akékoľvek.",
      importDrop: "Presuňte sem súbor alebo kliknite a vyberte ho",
      importFormats: "Excel (.xlsx), CSV alebo textový súbor · max 5 MB",
      importOrText: "…alebo vložte zoznam ako text",
      importBadType: "Nepodporovaný typ súboru. Nahrajte .xlsx, .csv alebo .txt (starý .xls uložte v Exceli ako .xlsx).",
      importPlaceholder: "Sem vložte zoznam zamestnancov…\n\nnapr.:\nJán Novák, 0905 123 456, predavač\nEva Malá\t0911 222 333\tskladníčka",
      importParse: "Rozpoznať zoznam",
      importParsing: "AI číta zoznam…",
      importSuccess: "Rozpoznaných {count} zamestnancov — skontrolujte a upravte údaje nižšie.",
      importNone: "V texte sa nepodarilo rozpoznať žiadnych zamestnancov. Skúste vložiť zoznam s menami a číslami.",
      importEmpty: "Najprv vložte text so zoznamom zamestnancov.",
      sendInvite: "Poslať SMS pozvánku so stiahnutím appky",
      employeesNone: "Vyplňte aspoň jedného zamestnanca alebo krok preskočte.",
      employeesPartialFail: "Nepodarilo sa vytvoriť: {names}. Skontrolujte údaje a skúste znova, alebo krok preskočte.",
      posterHeading: "Vytlačte QR plagát",
      posterHint: "Zaveste ho na pracovisko — zamestnanci ho naskenujú appkou a dochádzka sa zapíše sama. Obsahuje aj návod a QR na stiahnutie appky.",
      posterPrint: "Vytlačiť A4 plagát",
      posterPrinted: "Plagát odoslaný na tlač 🎉",
      posterLater: "Plagát viete kedykoľvek vytlačiť aj neskôr v detaile pracoviska.",
      doneHeading: "Všetko pripravené! 🎉",
      doneText: "Keď zamestnanec naskenuje QR kód na plagáte, prvý príchod uvidíte priamo na dashboarde.",
      doneSummaryWorkplace: "Pracovisko",
      doneSummaryEmployees: "Zamestnanci",
      doneSummaryInvites: "SMS pozvánky",
      startTour: "Prezrieť si administráciu (1 min)",
      finish: "Začať používať Effzone",
      back: "Späť",
      next: "Ďalej",
      skipStep: "Preskočiť tento krok",
      creating: "Pracujem…",
      genericError: "Niečo sa nepodarilo. Skúste to prosím znova.",
    },
    tour: {
      next: "Ďalej",
      prev: "Späť",
      done: "Hotovo",
      dashboardTitle: "Dashboard",
      dashboardDesc: "Prehľad dňa na jednom mieste — kto je v práci, odpracované hodiny a trendy tímu.",
      employeesTitle: "Zamestnanci",
      employeesDesc: "Pridávanie zamestnancov, SMS pozvánky do appky a priraďovanie na pracoviská.",
      workplacesTitle: "Pracoviská",
      workplacesDesc: "Každé pracovisko má vlastný QR kód. Tu si upravíte QR štýl a vytlačíte A4 plagát.",
      automationsTitle: "Automatizácie",
      automationsDesc: "Automatické ukončenie zmien, pripomienky a pravidlá — dochádzka sa stráži sama.",
      exportTitle: "Export",
      exportDesc: "Podklady pre mzdy na pár klikov — export dochádzky do Excelu za zvolené obdobie.",
      asistentTitle: "AI asistent",
      asistentDesc: "Opýtajte sa na dochádzku ľudskou rečou — asistent odpovedá z vašich dát.",
      requestsTitle: "Žiadosti",
      requestsDesc: "Zamestnanci posielajú žiadosti o úpravu dochádzky z appky, vy ich tu schvaľujete.",
      activityTitle: "Aktivita",
      activityDesc: "Živý prehľad všetkých udalostí — príchody, zmeny a dianie vo firme.",
      profileTitle: "Váš profil",
      profileDesc: "Nastavenia účtu, jazyk a tmavý režim nájdete tu dole. To je všetko — poďme na to!",
    },
    checklist: {
      runWizard: "Spustiť sprievodcu nastavením",
      runTour: "Prehliadka administrácie",
    },
  },
  addEmployeeDrawer: {
    title: "Pridať zamestnanca",
    name: "Meno",
    position: "Pozícia",
    email: "E-mail",
    phone: "Telefónne číslo",
    phoneHelper: "Číslo, ktorým sa zamestnanec prihlási do mobilnej aplikácie (napr. 0905 123 456).",
    assignWorkplaces: "Priradiť k pracoviskám",
    workplaceRequiredHint: "Bez priradeného pracoviska sa zamestnanec nevie prihlásiť do aplikácie.",
    noWorkplaceWarning: "Nie je vybraté žiadne pracovisko — zamestnanec sa nebude vedieť prihlásiť.",
    sendInvite: "Poslať SMS pozvánku do aplikácie",
    sendInviteHint: "Zamestnancovi príde SMS s odkazom na stiahnutie aplikácie Effzone.",
    create: "Vytvoriť",
    errorRequired: "Meno a telefónne číslo sú povinné.",
    errorGeneric: "Zamestnanca sa nepodarilo vytvoriť. Skúste to znova.",
    inviteSmsFailed: "Zamestnanec bol vytvorený, ale SMS pozvánku sa nepodarilo odoslať. Pošlite mu odkaz effzone.sk/mobile-app ručne."
  },
  pages: {
    dashboard: {
      title: "Prehľad",
      quickActions: "Rýchle akcie",
      addEmployeesTitle: "Pridajte zamestnancov",
      addEmployeesDesc: "Začnite pridaním zamestnancov do systému pre správu dochádzky.",
      addEmployeesBtn: "Pridať zamestnancov",
      addWorkplaceTitle: "Vytvorte pracovisko",
      addWorkplaceDesc: "Vytvorte pracoviská a vygenerujte QR kódy pre evidenciu dochádzky.",
      addWorkplaceBtn: "Pridať pracovisko",
      onboarding: {
        title: "Začíname — 4 kroky k prvej dochádzke",
        subtitle: "Hotovo {done} z {total}",
        step1Title: "Vytvorte pracovisko",
        step1Desc: "Stačí názov — poloha a geofencing sa dajú doplniť neskôr.",
        step1Btn: "Vytvoriť",
        step2Title: "Vytlačte QR plagát a nalepte ho na pracovisko",
        step2Desc: "V detaile pracoviska stlačte „Vytlačiť A4 plagát“ — obsahuje QR kód aj návod pre zamestnancov.",
        step2Btn: "Otvoriť pracoviská",
        step3Title: "Pridajte zamestnancov",
        step3Desc: "Meno + telefónne číslo. Nezabudnite priradiť pracovisko — bez neho sa zamestnanec neprihlási. Zamestnancovi automaticky odíde SMS s odkazom na aplikáciu.",
        step3Btn: "Pridať",
        step4Title: "Prvý príchod",
        step4Desc: "Zamestnanec si stiahne appku, naskenuje QR na pracovisku a prihlási sa telefónnym číslom. Hneď ho uvidíte tu na prehľade.",
      },
      presentListTitle: "Aktuálne na pracovisku",
      noPresent: "Momentálne nie je nikto na pracovisku.",
      noPosition: "Pozícia neuvedená",
      presence: {
        now: "Teraz",
        ofTeam: "z {total} ľudí je na pracovisku",
        noTeamYet: "Zatiaľ ste nepridali žiadnych zamestnancov",
        working: "Pracujú",
        onBreak: "Na prestávke",
        away: "Mimo",
        nobodyInHint: "Dnes si zatiaľ nikto neoznačil príchod.",
        addTeamCta: "Pridať zamestnancov"
      },
      feed: {
        title: "Nástenka",
        subtitle: "Posledných 20 udalostí v tíme",
        updatedAt: "Aktualizované o {time}",
        today: "Dnes",
        yesterday: "Včera",
        emptyTitle: "Zatiaľ sa nič nestalo",
        emptyHint: "Každý príchod, prestávka a odchod sa objaví tu — hneď ako si prvý človek označí príchod.",
        summary: {
          arrivals: "príchodov",
          breaks: "prestávok",
          departures: "odchodov"
        },
        kinds: {
          arrival: "Príchod",
          departure: "Odchod",
          breakStart: "Prestávka",
          breakEnd: "Návrat z prestávky",
          autoEnd: "Ukončené systémom"
        }
      },
      period: {
        title: "Ako tím pracoval",
        teamLabel: "Priemer tímu",
        byEmployeeLabel: "Podľa zamestnanca",
        autoEndedNote: "Ukončené systémom · {count} — nerátajú sa do priemerného odchodu ani času v práci",
        autoEndedShow: "Zobraziť",
        autoEndedHide: "Skryť"
      },
      filters: {
        employeeAll: "Celý tím",
        employeeLabel: "Zamestnanec"
      },
      kpis: {
        totalEmployees: "Zamestnanci celkom",
        atWorkplace: "Na pracovisku",
        onBreak: "Na prestávke",
        workedToday: "Pracovalo dnes",
        workplaces: "Pracoviská",
        checkinsToday: "Načítania dnes",
        checkinsBreakdown: "NFC {nfc} · QR {qr}",
        notPresent: "Neprítomní",
        onCustomStatus: "Vlastný stav"
      },
      workplacePresence: {
        title: "Kto je kde teraz",
        subtitle: "Aktuálne prítomní na pracoviskách",
        noData: "Momentálne nie je nikto na pracovisku."
      },
      statusBreakdown: {
        title: "Absencie a stavy",
        subtitle: "Za zvolené obdobie",
        noData: "Žiadne záznamy o stavoch za toto obdobie."
      },
      scoreboard: {
        title: "Prehľad zamestnancov",
        subtitle: "Odpracované hodiny, dni a časy za zvolené obdobie — klikni na hlavičku pre zoradenie",
        noData: "Za toto obdobie zatiaľ nie sú žiadne dochádzkové dáta.",
        noDataHint: "Tabuľka sa naplní, keď zamestnanci začnú označovať príchody a odchody.",
        colEmployee: "Zamestnanec",
        colHours: "Odpracované",
        colDays: "Dni",
        colArrival: "Ø príchod",
        colDeparture: "Ø odchod",
        colBreak: "Ø prestávka"
      },
      status: {
        atWorkplace: "Na pracovisku",
        onBreak: "Na prestávke"
      },
      charts: {
        weeklyTrend: "Dochádzka za 7 dní",
        arrivalsToday: "Príchody podľa hodiny",
        dayDetail: "Príchody a odchody podľa hodiny",
        weekly: "7 dní",
        today: "Dnes",
        byDay: "Po dňoch",
        present: "Prítomní",
        arrivals: "Príchody",
        departures: "Odchody",
        clickHint: "Kliknite na stĺpec pre zobrazenie zamestnancov v daný deň",
        noDayData: "V tento deň nie sú žiadne záznamy",
        noDayDataHint: "Skúste iný deň alebo prepnite na sedemdňový prehľad.",
        tooltip: {
          presentCount: "Prítomní · {count}",
          stillAtWork: "v práci",
          more: "ďalší: {count}",
          autoEndedNote: "Ukončil systém — čas odchodu nie je skutočný"
        },
        hoursTrendTitle: "Trend odpracovaných hodín",
        hoursTrendSubtitle: "Čisté hodiny po týždňoch",
        netHours: "Odpracované hodiny",
        weekOf: "Týždeň od {date}"
      },
      tasks: {
        title: "Úlohy",
        subtitle: "Čo tímu pribudlo a čo dobehlo",
        open: "Otvorené",
        openHint: "z toho {inProgress} rozrobených",
        overdue: "Po termíne",
        overdueHint: "otvorené s termínom v minulosti",
        completed7d: "Hotové (7 dní)",
        created7dHint: "za ten čas pribudlo {created}",
        recentLabel: "Posledné dianie",
        unassigned: "Bez riešiteľa",
        noRecent: "Zatiaľ sa nič nedialo.",
        noRecentHint: "Tu sa objaví, čo pribudlo a čo sa dokončilo.",
        emptyTitle: "Úlohy zatiaľ nikto nezaložil.",
        emptyHint: "Úloha vzniká v chate alebo v mobilnej aplikácii a vždy patrí niekomu z tímu. Keď ju niekto založí, uvidíte tu, ako sa hýbe.",
        statuses: {
          pending: "Zadaná",
          in_progress: "Rozrobená",
          completed: "Hotová",
          cancelled: "Zrušená"
        },
        priorities: {
          low: "Nízka",
          medium: "Stredná",
          high: "Vysoká"
        },
        detail: {
          title: "Detail úlohy",
          assignee: "Rieši",
          createdBy: "Zadal",
          created: "Vytvorená",
          dueDate: "Termín",
          priority: "Priorita",
          completed: "Dokončená",
          notes: "Poznámka",
          attachments: "Priložené zadanie",
          recordings: "Nahrávky",
          openFile: "Otvoriť súbor",
          showMore: "Zobraziť celé",
          showLess: "Zobraziť menej",
          truncated: "Súbor je dlhší — celý sa dá otvoriť cez odkaz v hlavičke.",
          contentUnavailable: "Obsah sa nepodarilo načítať, súbor sa dá otvoriť cez odkaz.",
          errorTitle: "Detail úlohy sa nepodarilo načítať.",
          errorHint: "Skúste to o chvíľu znova. Ak to potrvá, úloha mohla byť medzitým zmazaná."
        },
        events: {
          created: "Nová",
          completed: "Hotová",
          cancelled: "Zrušená",
          overdue: "Po termíne"
        }
      },
      devices: {
        title: "Zariadenia tímu",
        summary: "{employees} zamestnancov so zaznamenaným zariadením",
        platformsTab: "Platformy",
        appVersionsTab: "Verzie appky",
        employeesLabel: "Zamestnanci",
        appVersionsLabel: "Inštalácie",
        noData: "Zatiaľ nemáme žiadne dáta o zariadeniach.",
        noDataHint: "Zariadenie sa zaznamená, keď sa zamestnanec prihlási v mobilnej aplikácii alebo na webe.",
        mobilePlatforms: "Mobilné",
        allPlatforms: "Všetky",
        platforms: {
          ios: "iOS",
          android: "Android",
          macos: "macOS",
          windows: "Windows",
          linux: "Linux",
          web: "Web",
          unknown: "Neznáme"
        }
      },
      analytics: {
        averagesTitle: "Priemery za obdobie",
        averagesTeamSubtitle: "Za celý tím",
        teamTitle: "Výkonnosť tímu",
        periodRange: "Údaje od {from} do {to}",
        sectionRoutine: "Kedy chodia do práce",
        sectionWorkday: "Koľko času strávia v práci",
        sectionActivity: "Aktivita tímu",
        avgArrival: "Príchod do práce",
        avgDeparture: "Odchod z práce",
        avgWork: "Odpracovaný čas za deň",
        avgBreak: "Prestávka",
        avgDays: "Odpracované dni",
        activeEmployees: "Aktívni zamestnanci",
        avgArrivalHint: "V akom čase v priemere prídu do práce",
        avgDepartureHint: "Kedy v priemere odchádzajú domov",
        avgWorkHint: "Čistý čas v práci, bez prestávok",
        avgBreakHint: "Ako dlho v priemere trvá pauza",
        avgDaysHint: "Koľko dní v priemere odpracuje jeden človek",
        activeEmployeesHint: "Koľko ľudí malo aspoň jeden záznam",
        consistency: "Stabilita príchodov",
        consistencyHint: "Čím nižšie číslo, tým pravidelnejší príchody tímu",
        consistencyUnit: "minút rozptyl",
        topByHours: "Najviac odpracovaných hodín",
        topByDays: "Najviac odpracovaných dní",
        singleEmployeeNote: "Rebríčky sú dostupné pre celý tím.",
        noData: "Zatiaľ nemáme dostatok dát pre toto obdobie",
        noDataHint: "Priemery sa vypočítajú z prvých dokončených smien.",
        period7: "7 dní",
        period14: "14 dní",
        period30: "30 dní",
        period90: "90 dní",
        period365: "Rok"
      }
    },
    employees: {
      title: "Zamestnanci",
      addEmployee: "Pridať zamestnanca",
      searchPlaceholder: "Hľadať podľa mena zamestnanca...",
      list: {
        person: "Zamestnanec",
        group: {
          working: "V práci",
          onBreak: "Na prestávke",
          done: "Odpracované",
          away: "Bez záznamu"
        },
        previousDay: "Predchádzajúci deň",
        nextDay: "Nasledujúci deň",
        pickDay: "Vybrať deň",
        today: "Dnes",
        shift: "Smena",
        lastSeen: "Naposledy v práci {date}",
        appSeen: "v appke {date}",
        neverUsed: "Aplikáciu zatiaľ nepoužil",
        noAttendanceYet: "Aplikáciu má, dochádzku zatiaľ žiadnu",
        worked: "Odpracované",
        workplace: "Pracovisko",
        notify: "Poslať správu",
        totalWorked: "spolu {value}",
        emptyTitle: "Žiadny zamestnanec nesedí s filtrom",
        emptyHint: "Skúste zmeniť hľadanie, filter alebo dátum.",
        state: {
          working: "v práci",
          onBreak: "na prestávke",
          done: "odpracované",
          away: "bez záznamu"
        }
      },
      insights: {
        period30: "30 dní",
        period90: "90 dní",
        period365: "Rok",
        periodLabel: "Prehľad za {period}",
        loading: "Načítavam štatistiky...",
        noDevice: "Bez registrovaného zariadenia",
        noAttendance: "Žiadna dochádzka v tomto období",
        avgRoutine: "{arrival} → {departure} · {work}/deň · {days} dní",
        deviceTitle: "Zariadenie",
        averagesTitle: "Priemery",
        drawerTitle: "Prehľad za obdobie",
        avgBreak: "Priemerná prestávka",
        totalHours: "Celkom odpracované",
        systemVersion: "Verzia systému",
        lastDeviceUpdate: "Naposledy aktualizované",
        avgArrivalShort: "Príchod",
        avgDepartureShort: "Odchod",
        avgWorkShort: "Čas / deň",
        avgDaysShort: "Dní",
        platformUnknown: "Neznáma platforma",
        platforms: {
          ios: "iOS",
          android: "Android",
          macos: "macOS",
          windows: "Windows",
          linux: "Linux",
          web: "Web"
        }
      }
    },
    employeeProfile: {
      backToList: "Zamestnanci",
      openPage: "Otvoriť stránku",
      noPosition: "Pozícia neuvedená",
      notFound: "Tento zamestnanec neexistuje",
      notFoundHint: "Možno bol vymazaný, alebo patrí inej firme.",
      presence: {
        working: "V práci od {since} · {elapsed}",
        onBreak: "Na prestávke od {since}",
        lastSeen: "Naposledy v práci {when}",
        never: "Zatiaľ bez dochádzky"
      },
      actions: {
        message: "Napísať",
        edit: "Upraviť"
      },
      rhythm: {
        title: "Ako chodí",
        total: "Odpracované spolu",
        daysWorked: "Odpracované dni",
        verdict: {
          clockwork: "Chodí ako hodinky",
          regular: "Chodí pravidelne",
          varying: "Príchody sa rozchádzajú",
          irregular: "Chodí nepravidelne",
          noData: "Zatiaľ málo dát",
          sparse: "Prišiel menej než polovicu dní",
          none: "Za toto obdobie bez dochádzky"
        },
        spread: "príchody sa líšia o ±{min} min",
        coverage: "prišiel {worked} z {total} {unit}",
        unitWorkdays: "pracovných dní",
        unitDays: "dní",
        avgDay: "priemerne {value} denne",
        arrivalAround: "príchod okolo {time}",
        missing: "{days} bez záznamu",
        noEnd: "{days} bez odpípnutého odchodu",
        scopeMonth: "Mesiac",
        scopeYear: "Rok",
        previous: "Predchádzajúce obdobie",
        next: "Nasledujúce obdobie",
        dayOne: "deň",
        dayFew: "dni",
        dayMany: "dní"
      },
      calendar: {
        less: "menej hodín",
        more: "viac"
      },
      strip: {
        worked: "Odpracované",
        open: "Prebieha",
        auto: "Ukončené systémom",
        status: "Stav",
        missing: "Bez záznamu"
      },
      day: {
        nothing: "V tento deň nie je žiadny záznam",
        nothingHint: "Vyberte v kalendári deň s dochádzkou — zobrazí sa jeho priebeh.",
        noEndShort: "Neodpípnutý",
        shiftCount: "{count} smeny",
        habitMarker: "prerušovaná čiara = bežný príchod a odchod",
        autoNote: "Odchod v tento deň zapísala automatizácia, nie zamestnanec — odpracovaný čas preto nevieme.",
        deltaLater: "o {value} neskôr než zvyčajne",
        deltaEarlier: "o {value} skôr než zvyčajne",
        deltaMore: "o {value} viac než priemer",
        deltaLess: "o {value} menej než priemer",
        deltaSame: "ako zvyčajne",
        noRecords: "Vyberte deň v páse vyššie — zobrazí sa jeho priebeh.",
        kinds: {
          arrival: "Príchod",
          departure: "Odchod",
          auto_end: "Ukončené systémom",
          break_start: "Prestávka",
          status: "Stav"
        }
      },
      attention: {
        title: "Čo si všimnúť",
        autoEnded: "Zabudnutý odchod · {count} — smenu ukončil systém",
        staleOpen: "Neuzavretá smena · {count} — stále beží z minulého dňa",
        pendingRequests: "Žiadosti čakajúce na teba · {count}",
        statusDays: "{count} dní",
        open: "Otvoriť",
        clearTitle: "Nič, čo by si musel riešiť",
        clearHint: "Za toto obdobie nemá zabudnuté odchody, neuzavreté smeny ani čakajúce žiadosti."
      },
      facts: {
        title: "Fakty",
        startDate: "Nástup",
        birthday: "Narodeniny",
        workplaces: "Pracoviská",
        noWorkplace: "Bez priradeného pracoviska",
        device: "Zariadenie",
        noDevice: "Bez registrovaného zariadenia",
        appVersion: "Verzia aplikácie",
        lastSeen: "Naposledy v práci"
      },
      message: {
        title: "Správa pre {name}",
        subject: "Predmet",
        body: "Text správy",
        send: "Odoslať",
        sent: "Správa odoslaná",
        failed: "Správu sa nepodarilo odoslať"
      },
      edit: {
        title: "Upraviť zamestnanca",
        name: "Meno",
        position: "Pozícia",
        email: "E-mail",
        phone_number: "Telefónne číslo",
        workplaces: "Pracoviská",
        noWorkplaceWarning: "Bez pracoviska sa zamestnanec nevie prihlásiť do aplikácie.",
        saved: "Zmeny uložené",
        failed: "Zmeny sa nepodarilo uložiť"
      }
    },
    employeeDrawer: {
      tabs: {
        timeline: "Časová os",
        plan: "Plán dňa",
        message: "Správa"
      },
      selectedDate: "Vybraný dátum",
      dayPlan: {
        loading: "Načítavam plán dňa...",
        noPlan: "Zamestnanec nemá plán pre tento deň."
      }
    },
    workplaces: {
      title: "Pracoviská",
      addWorkplace: "Pridať pracovisko",
      searchPlaceholder: "Hľadať podľa názvu pracoviska...",
      count: "pracovísk",
      noResults: "Nenašli sa žiadne pracoviská."
    },
    automations: {
      title: "Automatizácie",
      description: "Push notifikácie a automatické akcie pri dlhej prestávke alebo zmeny.",
      lastRun: "Posledné spustenie",
      neverRun: "Zatiaľ nespustené",
      settings: "Nastavenia",
      history: "História",
      save: "Uložiť",
      enable: "Zapnúť",
      active: "Zapnuté",
      inactive: "Vypnuté",
      saved: "Nastavenia boli uložené.",
      enabled: "Automatizácia bola zapnutá.",
      toggleError: "Nepodarilo sa zmeniť stav automatizácie.",
      saveError: "Nepodarilo sa uložiť nastavenia.",
      fetchError: "Nepodarilo sa načítať automatizácie.",
      types: {
        long_break: {
          title: "Prestávka",
          description: "Upozorní zamestnanca, ak je na prestávke príliš dlho."
        },
        long_shift_reminder: {
          title: "Dlhá zmena",
          description: "Pripomenie ukončenie zmeny po prekročení počtu hodín."
        },
        auto_end_shift: {
          title: "Automatické ukončenie",
          description: "Automaticky ukončí zmenu a pošle notifikáciu."
        }
      },
      fields: {
        durationMinutes: "Trvanie (minúty)",
        durationHours: "Trvanie (hodiny)",
        notificationTitle: "Titulok notifikácie",
        notificationMessage: "Text notifikácie",
        helperBreak: "Upozorniť, ak je prestávka dlhšia ako táto hodnota.",
        helperShiftReminder: "Poslať pripomienku, ak je zmena dlhšia ako táto hodnota.",
        helperAutoEnd: "Automaticky ukončiť zmenu po prekročení tejto hodnoty.",
        placeholdersEmployee: "Môžete použiť {{employee_name}}.",
        placeholdersHours: "Môžete použiť {{employee_name}} a {{hours}}."
      },
      historyPanel: {
        emptyTitle: "Zatiaľ žiadna história",
        emptyDesc: "Táto automatizácia ešte nebola spustená.",
        success: "Úspešné",
        failed: "Zlyhalo",
        unknownEmployee: "Neznámy zamestnanec"
      }
    },
    requests: {
      title: "Žiadosti o zmeny",
      description: "Schvaľte alebo zamietnite žiadosti o zmeny od vašich zamestnancov.",
      searchPlaceholder: "Hľadať podľa mena zamestnanca...",
      approve: "Schváliť",
      reject: "Zamietnuť",
      pending: "Čakajúce",
      approved: "Schválené",
      rejected: "Zamietnuté",
      noRequests: "Nenašli sa žiadne čakajúce žiadosti."
    },
    reports: {
      title: "Podpora — hlásenia",
      description: "Hlásenia problémov, ktoré používatelia odoslali zatrasením telefónu. Po vyriešení dostane používateľ správu do chatu s AI asistentom.",
      filterOpen: "Nevybavené",
      filterResolved: "Vyriešené",
      filterAll: "Všetky",
      statusOpen: "Nevybavené",
      statusResolved: "Vyriešené",
      empty: "Žiadne hlásenia.",
      loadError: "Nepodarilo sa načítať hlásenia.",
      detailTitle: "Detail hlásenia",
      descriptionLabel: "Popis problému",
      screenshotLabel: "Screenshot",
      diagnostics: "Diagnostika",
      detailScreen: "Obrazovka",
      detailAppVersion: "Verzia appky",
      detailSystem: "Systém",
      detailDevice: "Zariadenie",
      createdAt: "Odoslané",
      markResolved: "Označiť ako vyriešené",
      resolveDialogTitle: "Vyriešiť hlásenie",
      resolveDialogText: "Používateľovi pošleme do chatu s AI asistentom správu, že jeho podnet je vyriešený. Môžete pridať krátku poznámku (napr. čo ste opravili).",
      resolveNoteLabel: "Poznámka pre používateľa (voliteľné)",
      resolveNotePlaceholder: "Napr.: Opravené v ďalšej verzii, ďakujeme!",
      resolvedSuccess: "Hlásenie vyriešené, používateľ dostal správu.",
      resolveError: "Nepodarilo sa vyriešiť hlásenie.",
      resolvedAtLabel: "Vyriešené"
    },
    userManagement: {
      title: "Správa používateľov",
      description: "Spravujte všetkých registrovaných používateľov",
      searchPlaceholder: "Hľadať podľa používateľského mena, emailu alebo spoločnosti..."
    },
    asistent: {
      heroTitle: "AI Asistent",
      heroSubtitle: "Nahraté dokumenty tvoria znalostnú bázu pre AI asistenta v mobilnej aplikácii vašich zamestnancov. Tu môžete spravovať obsah a otestovať odpovede pred nasadením.",
      stepUpload: "Nahraj dokumenty",
      stepManage: "Spravuj znalostnú bázu",
      stepTest: "Otestuj odpovede",
      uploadTitle: "Nahrať dokumenty",
      uploadHint: "Podporované formáty",
      selectFile: "Vybrať súbor",
      uploadButton: "Nahrať",
      dragDropHint: "Pretiahnite súbor sem alebo kliknite na výber",
      documentsTitle: "Znalostná báza",
      documentsEmpty: "Zatiaľ žiadne nahraté dokumenty. Nahrajte prvý dokument a asistent ho začne používať.",
      chatTitle: "Testovací chat",
      chatHint: "Vyskúšajte, ako asistent odpovedá na otázky z nahratých dokumentov.",
      chatPlaceholder: "Napíšte testovaciu otázku...",
      chatYou: "Vy",
      chatAssistant: "Asistent",
      uploadSuccess: "Dokument nahratý.",
      uploadSelectError: "Vyberte súbor.",
      uploadFailed: "Upload zlyhal.",
      chatFailed: "Odpoveď sa nepodarila.",
      sendButton: "Odoslať",
    },
    inAppMessages: {
      editor: {
        steps: {
          template: "Typ",
          content: "Obsah",
          style: "Štýl",
          audience: "Cieľová skupina"
        },
        templateSelector: {
          topBanner: "Horný banner",
          topBannerDesc: "Menej rušivý, posúva sa zhora.",
          centerModal: "Centrálny modál",
          centerModalDesc: "Vysoká pozornosť, centruje sa na obrazovke.",
          fullScreen: "Celá obrazovka",
          fullScreenDesc: "Maximálny dopad, pokrýva všetko."
        },
        contentEditor: {
          title: "Nadpis",
          body: "Text správy",
          imageUrl: "URL obrázka",
          showImage: "Zobraziť obrázok",
          primaryButton: "Primárne tlačidlo",
          secondaryButton: "Sekundárne tlačidlo",
          secondaryButtonHint: "Toto tlačidlo len zatvorí správu.",
          fullScreenSecondaryHint: "Pre full screen šablónu musí byť tlačidlo 'Zavrieť'.",
          magicGenerator: "AI Generátor",
          magicPromptPlaceholder: "Napíšte tému správy (napr. 'Špeciálna ponuka 20% zľava')",
          autoFill: "Automaticky vyplniť",
          generating: "Generuje sa...",
          generatingShort: "Generuje..."
        },
        actionEditor: {
          title: "Nastavenia primárnej akcie",
          inAppScreen: "In-App obrazovka",
          externalLink: "Externý odkaz",
          screenName: "Názov obrazovky",
          urlAddress: "URL adresa",
          parameters: "Parametre (JSON)",
          parametersHint: "Voliteľné dáta odovzdané obrazovke.",
          placeholderScreen: "napr. ProductDetails",
          placeholderUrl: "https://..."
        },
        destinations: {
          selectDestination: "Kam presmerovať po kliknutí",
          destinationHint: "Vyberte obrazovku v aplikácii. Parametre navigácie sú prednastavené.",
          home: { label: "Domov", desc: "Hlavný feed príspevkov" },
          chat_list: { label: "Chat", desc: "Zoznam konverzácií" },
          attendance: { label: "Dochádzka", desc: "Kalendár a zmeny" },
          settings: { label: "Nastavenia", desc: "Profil a nastavenia účtu" },
          create_post: { label: "Nový príspevok", desc: "Vytvorenie príspevku" },
          qr_scanner: { label: "Skenovať QR", desc: "Dochádzkový QR skener" },
          colleagues: { label: "Kolegovia", desc: "Zoznam kolegov" },
          permissions: { label: "Povolenia", desc: "Povolenia aplikácie" },
          wellbeing: { label: "Wellbeing", desc: "Spätná väzba a wellbeing" },
          about: { label: "O aplikácii", desc: "Informácie o aplikácii" },
          search: { label: "Vyhľadávanie", desc: "Globálne vyhľadávanie" },
        },
        styleEditor: {
          colorPalette: "Paleta farieb",
          typography: "Typografia",
          layout: "Rozloženie",
          image: "Obrázok",
          background: "Pozadie",
          textColor: "Farba textu",
          primaryBtnBg: "Pozadie prim. tlačidla",
          primaryBtnText: "Text prim. tlačidla",
          secondaryBtnBg: "Pozadie sek. tlačidla",
          secondaryBtnText: "Text sek. tlačidla",
          overlayColor: "Farba prekrytia",
          titleSize: "Veľkosť nadpisu",
          bodySize: "Veľkosť textu",
          cornerRadius: "Zaoblenie rohov",
          imageSize: "Veľkosť obrázka",
          imageBorderRadius: "Zaoblenie obrázka"
        },
        footer: {
          nextStep: "Ďalší krok",
          selectAudience: "Vyberte cieľovú skupinu na pokračovanie"
        },
        mobileTabs: {
          editor: "Editor",
          preview: "Náhľad"
        }
      },
      audience: {
        title: "Vybrať cieľovú skupinu",
        searchPlaceholder: "Hľadať zamestnancov...",
        filterActiveAttendance: "Len zamestnanci s aktívnou dochádzkou",
        employees: "zamestnancov",
        employee: "zamestnanec",
        withFcmToken: "s FCM tokenom",
        selectAll: "Vybrať všetko",
        deselectAll: "Zrušiť výber",
        noEmployeesFound: "Nenašli sa žiadni zamestnanci",
        active: "Aktívny",
        noFcmToken: "Bez FCM tokenu",
        selected: "vybraných",
        previewAndSend: "Náhľad a odoslanie"
      },
      preview: {
        title: "Náhľad a odoslanie",
        back: "Späť",
        edit: "Upraviť",
        selected: "Vybraných",
        withFcmToken: "S FCM tokenom",
        withoutToken: "Bez tokenu",
        warningNoToken: "vybraných zamestnancov nemá FCM token a budú preskočení.",
        pushNotification: "Push notifikácia (keď je aplikácia na pozadí)",
        inAppMessagePreview: "Náhľad in-app správy",
        realtimePreview: "Náhľad v reálnom čase",
        realtimePreviewDesc: "Pozrite sa, ako bude vaša správa vyzerať na zariadení",
        iLikeIt: "Páči sa mi to",
        iDontLikeIt: "Nepáči sa mi to - Upraviť",
        approved: "Schválené ✓",
        sendMessages: "Odoslať správy",
        sending: "Odosiela sa...",
        copy: "Kopírovať",
        copied: "Skopírované!",
        payload: "Payload"
      },
      defaults: {
        title: "📢 Posielajte správy všetkým naraz",
        body: "Vytvorte si vlastný dizajn správy a pošlite ju všetkým vybraným zamestnancom. Rýchle, jednoduché a efektívne! ✨",
        buttonText: "Začať",
        secondaryButtonText: "Zavrieť"
      },
      success: {
        messagesSent: "Správy odoslané!",
        successful: "úspešných",
        failed: "neúspešných"
      },
      errors: {
        loadingEmployees: "Chyba pri načítaní zamestnancov. Skúste to znova.",
        sendingMessages: "Chyba pri odosielaní správ. Skúste to znova.",
        generatingContent: "Chyba pri generovaní obsahu. Skúste to znova."
      }
    }
  }
};

